<template>
	<nav>
		<div class="custom-pc-nav">
			<img src="../../../../public/img/logo.png" alt="logo" @click="navigateToTarget('homePage', 0)" />
			<ul>
				<li v-for="(item, index) in navList" :key="index" :class="[{ 'li-active': index === activeNum }, 'transition']" @click="navigateToTarget(item.name, index)">
					{{ item.title }}
				</li>
			</ul>
		</div>
	</nav>
</template>

<script>
export default {
	name: "customPcNav",
	props: {
		navList: {
			type: Array,
			default: () => [],
		},
		activeNum: {
			type: [String, Number],
			default: 0,
		},
	},
	methods: {
		navigateToTarget(name, index) {
			this.showMenu = false;
			window.sessionStorage.setItem("nav", index);
			this.$emit("update:activeNum", index);
			this.$router.push({ name });
		},
	},
};
</script>

<style lang="scss" scoped>
.custom-pc-nav {
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 14.4rem;
	margin: 0 auto;
	padding: 0.16rem 0;
	img {
		display: block;
		width: 1.7rem;
		object-fit: cover;
	}
	ul {
		display: flex;
		align-content: center;
	}
	li {
		padding: 0.2rem 0.24rem;
		font-size: 0.16rem;
		color: #333;
		font-weight: bold;
		cursor: pointer;
		&:hover {
			color: #2cde00;
		}
		&:first-of-type {
			padding-left: 0;
		}
		&:last-of-type {
			padding-right: 0;
		}
	}
	.li-active {
		color: #2cde00;
	}
}
</style>
